<template>
  <div class="personal-center-wrap">
    <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
      <div class="top"></div>
      <div class="header">
        <div v-if="token" class="h-img" @click="goUserChange">
          <van-image round :src="
            (userInfo && userInfo.avatarUrl) ||
            require('@/assets/img/avatar.png')
          " />
          <van-image class="icon" :src="require('@/assets/img/editIcon.png')"></van-image>
        </div>

        <div v-if="token" class="nickname">
          {{
              (userInfo &&
                typeof userInfo.nickName === "string" &&
                userInfo.nickName.length > 0 &&
                userInfo.nickName) ||
              "游客"
          }}
        </div>
        <div v-else class="h-btn">
          <van-button round type="info" @click="goLogin" size="small">去登录</van-button>
        </div>


      </div>
      <div class="data-show">

      </div>
      <PCell :cellList="list" :needToken="!token" />
    </van-pull-refresh>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import apis from "@/config/apis";
import goLogin from "@/mixins/goLogin";
import checkoutLogin from "@/mixins/checkoutLogin";
import { routerPush } from "@/config/locationRouter";
import { reConfiguration } from "@/config";
// import { localDB } from "@/config/storage";

export default {
  name: "PersonalCenter",
  mixins: [goLogin, checkoutLogin],
  data() {
    return {
      // token: "",
      list: [

        {
          title: "我的直播",
          path: "/dw/myLive"
        },
        {
          title: "我的关注",
          path: "/dw/myFollow"
        },
        {
          title: "我的收藏",
          path: "/dw/myCollection"
        },
        {
          title: "我的学分",
        },
        {
          title: "我的会员",
        },

      ],
      isLoading: false
    };
  },
  created() {
    this.onShow();
    if (Date.now() < this.tokenTime && this.token) {
      // token有效的情况下，判断用户关注信息是否为默认
      // 默认则代表用户未请求过关注信息
      this.userRelatedData.income === "***" && this.getUserStatus();
    } else {
      // token无效，则区分有token与无token的区别
      this.token
        ? this.checkoutLogin(this.getInfo, this.$route.path)
        : this.$store.commit("user/RESET_USERRELATEDDATA");
    }

  },
  computed: {
    ...mapState({
      token: state => state.user.token,
      tokenTime: state => state.user.tokenTime,
      userInfo: state => state.user.userInfo,
      userRelatedData: state => state.user.userRelatedData
    })
  },
  methods: {
    ...mapActions({
      getUserStatus: "user/getUserStatus"
    }),


    goLogin() {
      this.login();
    },
    // token
    getInfo() {
      if (this.userRelatedData.fans === "***") {
        this.getUserStatus().catch(error => {
          console.log(error);
        });
      }
    },
    handleClickItem() {
      routerPush({ path: "/vip" });
    },
    onRefresh() {
      // 刷新判断有无token，无则直接关闭加载状态，有则去判断token是否有效
      this.token
        ? this.checkoutLogin(() => {
          this.getUserStatus()
            .then(() => {
              // 用户请求通过后在关闭加载刷新状态
              this.isLoading = false;
            })
            .catch(error => {
              console.log(error);
            });
        }, this.$route.path)
        : (this.isLoading = false);
    },
    onShow() {
      //兼容苹果手机
      let u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isPage = false;
      if (isiOS) {
        window.addEventListener("pageshow", function () {
          if (isPage) {
            reConfiguration(window.location.href, this.$route.name);
          }
        });
        window.addEventListener("pagehide", function () {
          isPage = true;
        });
      }
    },
    goUserChange() {
      this.$router.push("/dw/userChange");
    },
  }
};
</script>

<style lang="scss">
.personal-center-wrap {
  background: #f3f3f3;

  .top {
    height: 64px;
    background-color: #2d7bf2;
  }

  .header {
    width: 100vw;
    height: 200px;
    background-image: url("../../assets/img/banner4.png");
    background-size: 100% 100%;
    position: relative;
    padding-top: 35px;
    box-sizing: border-box;

    .h-img {
      display: flex;
      margin: 0 auto;
      width: 74px;
      position: relative;

      .icon {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }

      .van-image--round {
        width: 74px;
        height: 74px;
      }
    }

    .nickname {
      font-size: 16px;
      color: #fff;
      font-weight: 800;
      display: inline-block;
      text-align: center;
      width: 100%;
      margin-top: 15px;
    }

    .h-btn {
      display: flex;
      justify-content: center;
      margin-top: 15px;

      .van-button--round {
        background: #fff;
        color: #2d7bf2;
        height: 35px;
        width: 95px;
        border-radius: 37px;
        margin: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }

    .vip-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 92%;
      height: 37px;
      background: linear-gradient(92deg, #292929 0%, #545454 100%);
      opacity: 1;
      border-radius: 6px 6px 0px 0px;
      padding: 0 20px;
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      left: 15px;
      right: 15px;

      .icon {
        width: 16px;
        height: 15px;
      }

      .desc {
        flex: 1;
        padding-left: 5px;
        font-size: 13px;
        font-weight: 400;
        line-height: 18.5px;
        color: #f0d7b8;
      }

      .btn {
        font-size: 13px;
        font-weight: 400;
        line-height: 18.5px;
        color: #444444;
        padding: 2px 9.5px;
        background: linear-gradient(90deg, #f2e0ca 0%, #f5d0a3 100%);
        border-radius: 101px;
      }
    }
  }

  .data-show {
    display: flex;
    justify-content: space-around;
    /* padding: 11px 0; */
    background-color: #ffffff;
    border-bottom: 7px solid #ededed;

    .items {
      width: 25%;
      text-align: center;
      display: flex;
      flex-direction: column;

      .nums {
        font-size: 18px;
        font-weight: bold;
        color: #444444;
        line-height: 1.5;
        width: 100%;
        display: inline-block;
      }

      .text {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #444444;
      }
    }
  }
}
</style>
